/**
 * Defines constants for use with HTTP headers.
 */
export const headerConstants = {
    /**
     * The accept language header.
     */
    ACCEPT_LANGUAGE: 'accept-language',

    /**
     * The accept ranges header.
     */
    ACCEPT_RANGES: 'accept-ranges',

    /**
     * The content transfer encoding header.
     */
    CONTENT_TRANSFER_ENCODING: 'content-transfer-encoding',

    /**
     * The transfer encoding header.
     */
    TRANSFER_ENCODING: 'transfer-encoding',

    /**
     * The server header.
     */
    SERVER: 'server',

    /**
     * The location header.
     */
    LOCATION: 'location',

    /**
     * The Last-Modified header
     */
    LAST_MODIFIED: 'Last-Modified',

    /**
     * The data service version.
     */
    DATA_SERVICE_VERSION: 'dataserviceversion',

    /**
     * The maximum data service version.
     */
    MAX_DATA_SERVICE_VERSION: 'maxdataserviceversion',

    /**
     * The master Windows Azure Storage header prefix.
     */
    PREFIX_FOR_STORAGE: 'x-ms-',

    /**
     * The client request Id header.
     */
    CLIENT_REQUEST_ID: 'x-ms-client-request-id',

    /**
     * The header that specifies the approximate message count of a queue.
     */
    APPROXIMATE_MESSAGES_COUNT: 'x-ms-approximate-messages-count',

    /**
     * The Authorization header.
     */
    AUTHORIZATION: 'authorization',

    /**
     * The header that specifies public access to blobs.
     */
    BLOB_PUBLIC_ACCESS: 'x-ms-blob-public-access',

    /**
     * The header for the blob type.
     */
    BLOB_TYPE: 'x-ms-blob-type',

    /**
     * The header for the type.
     */
    TYPE: 'x-ms-type',

    /**
     * Specifies the block blob type.
     */
    BLOCK_BLOB: 'blockblob',

    /**
     * The CacheControl header.
     */
    CACHE_CONTROL: 'cache-control',

    /**
     * The header that specifies blob caching control.
     */
    BLOB_CACHE_CONTROL: 'x-ms-blob-cache-control',

    /**
     * The header that specifies caching control.
     */
    FILE_CACHE_CONTROL: 'x-ms-cache-control',

    /**
     * The copy status.
     */
    COPY_STATUS: 'x-ms-copy-status',

    /**
     * The copy completion time
     */
    COPY_COMPLETION_TIME: 'x-ms-copy-completion-time',

    /**
     * The copy status message
     */
    COPY_STATUS_DESCRIPTION: 'x-ms-copy-status-description',

    /**
     * The copy identifier.
     */
    COPY_ID: 'x-ms-copy-id',

    /**
     * Progress of any copy operation
     */
    COPY_PROGRESS: 'x-ms-copy-progress',

    /**
     * The copy action.
     */
    COPY_ACTION: 'x-ms-copy-action',

    /**
     * The ContentID header.
     */
    CONTENT_ID: 'content-id',

    /**
     * The ContentEncoding header.
     */
    CONTENT_ENCODING: 'content-encoding',

    /**
     * The header that specifies blob content encoding.
     */
    BLOB_CONTENT_ENCODING: 'x-ms-blob-content-encoding',

    /**
     * The header that specifies content encoding.
     */
    FILE_CONTENT_ENCODING: 'x-ms-content-encoding',

    /**
     * The ContentLangauge header.
     */
    CONTENT_LANGUAGE: 'content-language',

    /**
     * The header that specifies blob content language.
     */
    BLOB_CONTENT_LANGUAGE: 'x-ms-blob-content-language',

    /**
     * The header that specifies content language.
     */
    FILE_CONTENT_LANGUAGE: 'x-ms-content-language',

    /**
     * The ContentLength header.
     */
    CONTENT_LENGTH: 'content-length',

    /**
     * The header that specifies blob content length.
     */
    BLOB_CONTENT_LENGTH: 'x-ms-blob-content-length',

    /**
     * The header that specifies content length.
     */
    FILE_CONTENT_LENGTH: 'x-ms-content-length',

    /**
     * The ContentDisposition header.
     */
    CONTENT_DISPOSITION: 'content-disposition',

    /**
     * The header that specifies blob content disposition.
     */
    BLOB_CONTENT_DISPOSITION: 'x-ms-blob-content-disposition',

    /**
     * The header that specifies content disposition.
     */
    FILE_CONTENT_DISPOSITION: 'x-ms-content-disposition',

    /**
     * The ContentMD5 header.
     */
    CONTENT_MD5: 'content-md5',

    /**
     * The header that specifies blob content MD5.
     */
    BLOB_CONTENT_MD5: 'x-ms-blob-content-md5',

    /**
     * The header that specifies content MD5.
     */
    FILE_CONTENT_MD5: 'x-ms-content-md5',

    /**
     * The ContentRange header.
     */
    CONTENT_RANGE: 'Content-Range',

    /**
     * The ContentType header.
     */
    CONTENT_TYPE: 'Content-Type',

    /**
     * The header that specifies blob content type.
     */
    BLOB_CONTENT_TYPE: 'x-ms-blob-content-type',

    /**
     * The header that specifies content type.
     */
    FILE_CONTENT_TYPE: 'x-ms-content-type',

    /**
     * The header for copy source.
     */
    COPY_SOURCE: 'x-ms-copy-source',

    /**
     * The header that specifies the date.
     */
    DATE: 'date',

    /**
     * The header that specifies the date.
     */
    MS_DATE: 'x-ms-date',

    /**
     * The header to delete snapshots.
     */
    DELETE_SNAPSHOT: 'x-ms-delete-snapshots',

    /**
     * The ETag header.
     */
    ETAG: 'etag',

    /**
     * The IfMatch header.
     */
    IF_MATCH: 'if-match',

    /**
     * The IfModifiedSince header.
     */
    IF_MODIFIED_SINCE: 'if-modified-since',

    /**
     * The IfNoneMatch header.
     */
    IF_NONE_MATCH: 'if-none-match',

    /**
     * The IfUnmodifiedSince header.
     */
    IF_UNMODIFIED_SINCE: 'if-unmodified-since',

    /**
     * Specifies snapshots are to be included.
     */
    INCLUDE_SNAPSHOTS_VALUE: 'include',

    /**
     * Specifies that the content-type is JSON.
     */
    JSON_CONTENT_TYPE_VALUE: 'application/json;',

    /**
     * The header that specifies lease ID.
     */
    LEASE_ID: 'x-ms-lease-id',

    /**
     * The header that specifies the lease break period.
     */
    LEASE_BREAK_PERIOD: 'x-ms-lease-break-period',

    /**
     * The header that specifies the proposed lease identifier.
     */
    PROPOSED_LEASE_ID: 'x-ms-proposed-lease-id',

    /**
     * The header that specifies the lease duration.
     */
    LEASE_DURATION: 'x-ms-lease-duration',

    /**
     * The header that specifies the source lease ID.
     */
    SOURCE_LEASE_ID: 'x-ms-source-lease-id',

    /**
     * The header that specifies lease time.
     */
    LEASE_TIME: 'x-ms-lease-time',

    /**
     * The header that specifies lease status.
     */
    LEASE_STATUS: 'x-ms-lease-status',

    /**
     * The header that specifies lease state.
     */
    LEASE_STATE: 'x-ms-lease-state',

    /**
     * Specifies the page blob type.
     */
    PAGE_BLOB: 'PageBlob',

    /**
     * The header that specifies page write mode.
     */
    PAGE_WRITE: 'x-ms-page-write',

    /**
     * The header that specifies file range write mode.
     */
    FILE_WRITE: 'x-ms-write',

    /**
     * The header that specifies whether the response should include the inserted entity.
     */
    PREFER: 'Prefer',

    /**
     * The header value which specifies that the response should include the inserted entity.
     */
    PREFER_CONTENT: 'return-content',

    /**
     * The header value which specifies that the response should not include the inserted entity.
     */
    PREFER_NO_CONTENT: 'return-no-content',

    /**
     * The header prefix for metadata.
     */
    PREFIX_FOR_STORAGE_METADATA: 'x-ms-meta-',

    /**
     * The header prefix for properties.
     */
    PREFIX_FOR_STORAGE_PROPERTIES: 'x-ms-prop-',

    /**
     * The Range header.
     */
    RANGE: 'Range',

    /**
     * The header that specifies if the request will populate the ContentMD5 header for range gets.
     */
    RANGE_GET_CONTENT_MD5: 'x-ms-range-get-content-md5',

    /**
     * The format string for specifying ranges.
     */
    RANGE_HEADER_FORMAT: 'bytes:%d-%d',

    /**
     * The header that indicates the request ID.
     */
    REQUEST_ID: 'x-ms-request-id',

    /**
     * The header for specifying the sequence number.
     */
    SEQUENCE_NUMBER: 'x-ms-blob-sequence-number',

    /**
     * The header for specifying the If-Sequence-Number-EQ condition.
     */
    SEQUENCE_NUMBER_EQUAL: 'x-ms-if-sequence-number-eq',

    /**
     * The header for specifying the If-Sequence-Number-LT condition.
     */
    SEQUENCE_NUMBER_LESS_THAN: 'x-ms-if-sequence-number-lt',

    /**
     * The header for specifying the If-Sequence-Number-LE condition.
     */
    SEQUENCE_NUMBER_LESS_THAN_OR_EQUAL: 'x-ms-if-sequence-number-le',

    /**
     * The header that specifies sequence number action.
     */
    SEQUENCE_NUMBER_ACTION: 'x-ms-sequence-number-action',

    /**
     * The header for the blob content length.
     */
    SIZE: 'x-ms-blob-content-length',

    /**
     * The header for snapshots.
     */
    SNAPSHOT: 'x-ms-snapshot',

    /**
     * Specifies only snapshots are to be included.
     */
    SNAPSHOTS_ONLY_VALUE: 'only',

    /**
     * The header for the If-Match condition.
     */
    SOURCE_IF_MATCH: 'x-ms-source-if-match',

    /**
     * The header for the If-Modified-Since condition.
     */
    SOURCE_IF_MODIFIED_SINCE: 'x-ms-source-if-modified-since',

    /**
     * The header for the If-None-Match condition.
     */
    SOURCE_IF_NONE_MATCH: 'x-ms-source-if-none-match',

    /**
     * The header for the If-Unmodified-Since condition.
     */
    SOURCE_IF_UNMODIFIED_SINCE: 'x-ms-source-if-unmodified-since',

    /**
     * The header for data ranges.
     */
    STORAGE_RANGE: 'x-ms-range',

    /**
     * The header for storage version.
     */
    STORAGE_VERSION: 'x-ms-version',

    /**
     * The current storage version header value.
     */
    TARGET_STORAGE_VERSION: '2015-12-11',

    /**
     * The UserAgent header.
     */
    USER_AGENT: 'user-agent',

    /**
     * The pop receipt header.
     */
    POP_RECEIPT: 'x-ms-popreceipt',

    /**
     * The time next visibile header.
     */
    TIME_NEXT_VISIBLE: 'x-ms-time-next-visible',

    /**
     * The approximate message counter header.
     */
    APPROXIMATE_MESSAGE_COUNT: 'x-ms-approximate-message-count',

    /**
     * The lease action header.
     */
    LEASE_ACTION: 'x-ms-lease-action',

    /**
     * The accept header.
     */
    ACCEPT: 'accept',

    /**
     * The accept charset header.
     */
    ACCEPT_CHARSET: 'Accept-Charset',

    /**
     * The host header.
     */
    HOST: 'host',

    /**
     * The correlation identifier header.
     */
    CORRELATION_ID: 'x-ms-correlation-id',

    /**
     * The group identifier header.
     */
    GROUP_ID: 'x-ms-group-id',

    /**
     * The share quota header.
     */
    SHARE_QUOTA: 'x-ms-share-quota',

    /**
     * The max blob size header.
     */
    BLOB_CONDITION_MAX_SIZE: 'x-ms-blob-condition-maxsize',

    /**
     * The append blob position header.
     */
    BLOB_CONDITION_APPEND_POSITION: 'x-ms-blob-condition-appendpos',

    /**
     * The append blob append offset header.
     */
    BLOB_APPEND_OFFSET: 'x-ms-blob-append-offset',

    /**
     * The append blob committed block header.
     */
    BLOB_COMMITTED_BLOCK_COUNT: 'x-ms-blob-committed-block-count',

    /**
     * If the data and application metadata are completely encrypted using the specified algorithm.
     */
    SERVER_ENCRYPTED: 'x-ms-server-encrypted',

    /**
     * The SME authorization header.
     */
    SME_AUTHORIZATION: 'x-ms-sme-authorization',

    /**
     * The SME AAD authorization header.
     */
    SME_AAD_AUTHORIZATION: 'authorization-aad',

     /**
     * The secure extension data header
     */
    SECURE_EXTENSION: 'x-ms-sme-secureExtension',

    /**
     * The Use Laps Header.
     */
    USE_LAPS: 'x-ms-sme-useLaps',

    /**
     * The Laps local admin name.
     */
    LAPS_LOCALADMINNAME: 'x-ms-sme-lapsLocalAdminName',

    /**
     * Flag to log audit for the request
     */
    LOG_AUDIT: 'x-ms-sme-log-audit',

    /**
     * Flag to log telemetry for the request
     */
    LOG_TELEMETRY: 'x-ms-sme-log-telemetry',

    /**
     * Name of module making the request
     */
    MODULE_NAME: 'x-ms-sme-module-name',

    /**
     * Version of module making the request.
     */
    MODULE_VERSION: 'x-ms-sme-module-version',

    /**
     * PowerShell JEA endpoint.
     */
    POWERSHELL_ENDPOINT: 'x-ms-sme-jea-endpoint',

    /**
     * Cross-site request forgery token.
     * Use `X-XSRF-TOKEN` for the header name and `XSRF-TOKEN` for the cookie name.
     */
    CROSS_SITE_REQUEST_FORGERY_TOKEN: 'x-xsrf-token',

    /**
     * Authentication mechanism request.
     */
    AUTHENTICATION_MECHANISM: 'x-ms-sme-authentication-mechanism',

    /**
     * Version of requested static content.
     */
    STATIC_VERSION: 'x-ms-sme-static-version'
};

export const enum HttpStatusCode {
    // GenericError is defined for Status code 0. It has been observed when a http call was not completed due to
    // network communication error, security error, the gateway server was not running or something else, however
    // it doesn't give exact reason of the error.
    GenericError = 0,

    CorsRequestFailed = 0,
    Continue = 100,
    SwitchingProtocols = 101,
    Ok = 200,
    Created = 201,
    Accepted = 202,
    NonAuthoritativeInformation = 203,
    NoContent = 204,
    ResetContent = 205,
    PartialContent = 206,
    Ambiguous = 300,
    MultipleChoices = 300,
    Moved = 301,
    MovedPermanently = 301,
    Found = 302,
    Redirect = 302,
    RedirectMethod = 303,
    SeeOther = 303,
    NotModified = 304,
    UseProxy = 305,
    Unused = 306,
    RedirectKeepVerb = 307,
    TemporaryRedirect = 307,
    BadRequest = 400,
    Unauthorized = 401,
    PaymentRequired = 402,
    Forbidden = 403,
    NotFound = 404,
    MethodNotAllowed = 405,
    NotAcceptable = 406,
    ProxyAuthenticationRequired = 407,
    RequestTimeout = 408,
    Conflict = 409,
    Gone = 410,
    LengthRequired = 411,
    PreconditionFailed = 412,
    RequestEntityTooLarge = 413,
    RequestUriTooLong = 414,
    UnsupportedMediaType = 415,
    RequestedRangeNotSatisfiable = 416,
    ExpectationFailed = 417,
    UpgradeRequired = 426,
    PreconditionRequired = 428,
    InternalServerError = 500,
    NotImplemented = 501,
    BadGateway = 502,
    ServiceUnavailable = 503,
    GatewayTimeout = 504,
    HttpVersionNotSupported = 505
}

export enum HttpResponseTypes {
    Json = 'application/json',
}
